module.exports = __webpack_public_path__ + "static/media/stvbg.3213dc72.jpg";